module.exports = __webpack_public_path__ + "img/p6.2523f892.png";